<template>
  <div class="box-car">
    <div class="car-title" @click="btnClick(info.id)"  style="cursor: pointer">
      <div class="img-p">
        <img v-complete:src="info.logo" alt="" />
        <p>{{ info.title }}</p>
      </div>
    </div>
    <!-- {{ mydata.VUE_APP_BASE_HOST + info.logo }} -->
    <div class="car-content">
      <p>{{ info.alias }}</p>
      <p>{{ info.intro }}</p>
    </div>
  </div>
</template>

<script setup>
import { useIdGetUrl } from "@/utils/slide.js";
import { reactive } from "vue";
import { useRouter } from "vue-router";

let router = useRouter();

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

// 按钮点击事件
function btnClick(id) {
  // 获取地址
  let path = useIdGetUrl(id);
  // 进行跳转
  router.push({
    path: path,
  });
  // console.log(props.info.logo,"111111222222")
}
</script>

<style scoped lang="scss">
.box-car {
  width: 218px;
  height: 180px;
  // border: 1px solid blue;
  border-radius: 8px;
  background-color: #ffffff;
  // box-shadow: 0px 5px 40px 0px #0000000d;
  //////////////////////////
  .car-title {
    width: 100%;
    height: 72px;
    // display: flex;
    // padding-left: 30px;
    // padding-top: 23px;
    border-radius: 8px 8px 0px 0px;
    background-color: #d2cece62;
    display: flex;
    justify-content: center;
    align-items: center;
    .img-p {
      height: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      //   border: 1px solid red;
      img {
        display: block;
        width: 40px;
        height: 40px;
        // margin-right: 10px;
      }
      p {
        font-size: 18px;
        font-weight: 700;
        color: #333333;
      }
    }
  }

  ////////////////////////
  .car-content {
    width: 100%;
    // height: 142px;
    padding: 16px;

    p:nth-of-type(1) {
      height: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 12px;
      // border:1px solid red;
    }
    p:nth-of-type(2) {
      // width: 172px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      // border:1px solid red;

      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
    }
  }
}

.box-car:hover {
  .car-title {
    background-color: #009de0;
    p {
      color: #ffffff !important;
    }
  }
}
</style>